const KEY = "sgdfw-snapshot";

export function saveSnapshot(key, data) {
  try {
    localStorage.setItem(`${KEY}:${key}`, JSON.stringify({ data, at: Date.now() }));
  } catch {
    /* storage full/blocked */
  }
}

export function loadSnapshot(key) {
  try {
    const raw = localStorage.getItem(`${KEY}:${key}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setLiveBadge(count) {
  try {
    if (!("setAppBadge" in navigator)) return;
    if (count > 0) navigator.setAppBadge(count).catch(() => {});
    else if ("clearAppBadge" in navigator) navigator.clearAppBadge().catch(() => {});
  } catch {
    /* badging unsupported */
  }
}
